export default {
    stickers: {
        title: 'Tarroja',
        stickerOpacity: 'Läpinäkyvyys tarraan',
        stickerColor: 'Tarra väri',
        shapes: {
            title: 'Muodot',
            rectangle: 'Suorakulmio',
            circle: 'ympyrä',
            triangle: 'Kolmio',
        },
        emojis: {
            title: 'Emojit',
        },
    },
};
